import { PlatformMode } from 'constants/platformMode'
import { useAppSelector } from 'hooks/redux'

// The mode is a lab-wide setting; the server sends it with /me.
export const usePlatformMode = () => {
  const mode = useAppSelector((state) => state.init.platformMode ?? PlatformMode.TestSmarter)

  return {
    mode,
    isTestSmarterMode: mode === PlatformMode.TestSmarter,
    isIRhythmMode: mode === PlatformMode.IRhythm,
  }
}

// HST duration is clinical: in iRhythm mode a DME doesn't choose the nights, and sets
// one set of conditions for all of them. Lab staff still choose.
export const useHstDurationFixed = (context?: 'LAB' | 'DME', testType?: string): boolean => {
  const { isIRhythmMode } = usePlatformMode()

  return context === 'DME' && isIRhythmMode && testType === 'HST'
}
